module.exports = __webpack_public_path__ + "static/media/infection.afc69f00.svg";